import clsx from "clsx";
import { Button, Icon } from "@/shared/ui";

type Props = {
  title: string;
  onDelete: () => void;
  index: number;
};

export default function CreateEntityColumn({ title, index, onDelete }: Props) {
  return (
    <div className="flex items-center gap-1.5 h-[2.625rem]">
      <div
        className={clsx(
          "h-full grow flex items-center justify-between rounded-[0.5rem]",
          "text-14 font-medium px-4",
          "bg-gradient-to-r from-[#21652C]/20 to-[#21652C]/5 text-[#84FF97]",
        )}
      >
        {title}
        <div
          className={clsx(
            "text-12 w-[1.125rem] h-[1.125rem] flex items-center justify-center rounded-[0.325rem]",
            "bg-gradient-to-r from-[#21652C]/20 to-[#21652C]/5 text-[#84FF97]",
          )}
        >
          {index}
        </div>
      </div>
      <Button className="w-[2.625rem] h-[2.625rem] p-0 shrink-0" onClick={onDelete}>
        <Icon name="trash" className="w-4" />
      </Button>
    </div>
  );
}
